import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Button, Form, Alert, Spinner } from 'react-bootstrap';
import {
  fetchSalesInstituteById,
  updateSalesInstitute
} from '../../../services/salesInstitutesService';
import { fetchUsers } from '../../../services/userService';

const EditSalesInstitute: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    institute_name: '',
    assigned_to: ''
  });
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const instituteData = await fetchSalesInstituteById(id);
        const userData = await fetchUsers();
        setFormData({
          institute_name: instituteData.institute_name,
          assigned_to: instituteData.assigned_to
        });
        setUsers(userData);
      } catch (err) {
        setError('Failed to fetch institute details.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const handleChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target as HTMLInputElement | HTMLSelectElement;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await updateSalesInstitute(id, formData);
      setMessage('Institute updated successfully!');
      setTimeout(
        () => navigate('/sales/sales-institutes/all-institutes'),
        1500
      );
    } catch (err) {
      setError('Failed to update institute. Please try again.');
    }
  };

  if (loading)
    return <Spinner animation="border" className="d-block mx-auto" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <div className="container mt-4">
      <Card className="shadow p-4">
        <Card.Body>
          <Card.Title className="fw-bold">Edit Sales Institute</Card.Title>

          {message && <Alert variant="success">{message}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            {/* Institute Name */}
            <Form.Group className="mb-3">
              <Form.Label>Institute Name</Form.Label>
              <Form.Control
                type="text"
                name="institute_name"
                value={formData.institute_name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            {/* Assigned To */}
            <Form.Group className="mb-3">
              <Form.Label>Assigned To</Form.Label>
              <Form.Select
                name="assigned_to"
                value={formData.assigned_to}
                onChange={handleChange}
                required
              >
                <option value="">Select User</option>
                {users.map(user => (
                  <option key={user.user_id} value={user.user_id}>
                    {user.username}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* Buttons */}
            <div className="d-flex justify-content-between">
              <Button
                variant="secondary"
                onClick={() => navigate('/sales/institutes')}
              >
                Cancel
              </Button>
              <Button type="submit" variant="primary">
                Update Institute
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default EditSalesInstitute;
